const hour = 1000 * 60 * 60
const day = hour * 24

export function msToDays(ms: number): number {
  return Math.ceil(ms / day)
}
